
<div class="h-full w-full">
  <div
    v-if="true"
    class="flex h-full w-full flex-col md:flex-row"
  >
    <l-map
      ref="map"
      class="h-full w-full map"
      :zoom="mapZoom"
      :min-zoom="minZoom"
      :center="mapCenter"
      :options="{ preferCanvas: true, zoomControl: false, worldCopyJump: true }"
      @ready="mapMounted"
    >
      <l-tile-layer
        :url="tileLayerUrl"
        :attribution="mapAttribution"
      />
      <l-control position="bottomleft">
        <MapControls
          v-if="mapObject"
          :map-object="mapObject"
        />
      </l-control>
      <l-control position="topright">
        <div class="text-app flex flex-row gap-2">
          <router-link
            v-if="false"
            :to="{ name: 'Funding' }"
            class="hidden sm:inline-flex h-11 w-11 p-0 bg-white border-app border-2 shadow rounded hover:outline outline-2 outline-offset-1 dark:bg-gray-700 items-center justify-center"
          >
            <fa-icon
              icon="fa-solid fa-beer"
              fixed-width
            />
          </router-link>
          <a
            href="#"
            class="h-11 w-11 p-0 bg-white border-app border-2 shadow rounded hover:outline outline-2 outline-offset-1 dark:bg-gray-700 inline-flex items-center justify-center"
            @click.prevent="openWelcomeModalManual"
          >
            <fa-icon
              icon="fa-solid fa-star"
              fixed-width
            />
          </a>
          <a
            href="#"
            class="hidden sm:inline-flex h-11 w-11 p-0 bg-white border-app border-2 shadow rounded hover:outline outline-2 outline-offset-1 dark:bg-gray-700 items-center justify-center"
            @click.prevent="toggleTheme"
          >
            <fa-icon
              :icon="colorSchemeIcon"
              fixed-width
            />
          </a>
          <router-link
            :to="{ name: 'About' }"
            class="h-11 w-11 p-0 bg-white border-app border-2 shadow rounded hover:outline outline-2 outline-offset-1 dark:bg-gray-700 inline-flex items-center justify-center"
          >
            <fa-icon
              icon="fa-solid fa-info"
              fixed-width
            />
          </router-link>
        </div>
      </l-control>
      <MapLookup />
    </l-map>
  </div>
  <div
    v-else
    class="h-full flex justify-center items-center"
  >
    <fa-icon
      icon="fa-solid fa-refresh"
      spin
      size="4x"
      fixed-size
    />
  </div>
  <router-view />
</div>
